/**
 * @Author: sunchao
 * @Date:   2019/5/27 17:25
 */
const config = {
    // api接口地址
    apiUrl: 'https://wsgaj.chutianyun.gov.cn/gateway',
    // apiUrl: '/gateway',
    // 项目地址
    wechatBase: 'https://wsgaj.chutianyun.gov.cn/weixin/',
    // 网关地址
    gateWayUrl: "https://wsgaj.chutianyun.gov.cn/apis/",
    // gateWayUrl: "/apis",
};

export default config;
